import { USER_INFO, WA_LOGIN_CREATE, WA_LOGIN_STATUS } from "../apis/user"

// 登录成功后写入token并拉取用户信息(登录页/WhatsApp登录等待页共用)
// 同时承载WhatsApp登录会话的创建与轮询(登录页直启WhatsApp/等待页二维码兜底共用)
export default {
  data() {
    return {
      sessionToken: "",
      waLink: "",
      expiresIn: 300,
      createdAt: 0,
      isExpired: false,
      pollTimer: null
    }
  },
  computed: {
    isMobile() {
      return /Android|iPhone|iPad|iPod/i.test(window.navigator.userAgent)
    },
    qrcode() {
      // homeMap扫码时直接写sessionStorage(未走vuex commit),这里做兜底
      return this.$store.state.qrcode || sessionStorage.getItem("cdb_qrcode")
    }
  },
  methods: {
    loginByToken(token) {
      this.$store.commit("token", token)
      // 实名登录成功,清掉游客标记
      this.$store.commit("userType", "")
      this.loadUser()
    },
    loadUser() {
      this.$loading(true)
      this.$get(
        USER_INFO,
        {},
        (res) => {
          this.$loading(false)
          if (res.user) {
            this.$store.commit("user", res.user)
            this.$toast(this.i18n.msg_success_login)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user
            })
              .then(() => {
                this.loadUser()
              })
              .catch(() => {
                this.$store.commit("token", null)
              })
          }
        },
        (err) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          }).then(() => {
            this.$store.commit("token", null)
          })
        }
      )
    },
    // 创建WhatsApp登录会话并开始轮询;onCreated在创建成功后回调(如登录页直接唤起WhatsApp)
    createSession(onCreated) {
      this.stopPolling()
      this.isExpired = false
      this.waLink = ""
      this.$loading(true)
      // 扫码进入时把机柜qrcode绑进会话,批准后回传继续租借
      const _query = {}
      if (this.qrcode) {
        _query.qrcode = this.qrcode
      }
      // 登录前被拦截的页面(如未支付订单),批准后回传,登录完成直接跳回
      if (this.$route.query.redirect) {
        _query.redirect = this.$route.query.redirect
      }
      this.$post(
        WA_LOGIN_CREATE,
        _query,
        (res) => {
          this.$loading(false)
          this.sessionToken = res.sessionToken
          this.waLink = res.waLink
          this.expiresIn = res.expiresIn || 300
          this.createdAt = Date.now()
          this.startPolling()
          if (onCreated) {
            onCreated(res)
          }
        },
        (err) => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
          this.isExpired = true
        }
      )
    },
    startPolling() {
      this.stopPolling()
      const poll = () => {
        // 会话整体超时,转过期态
        if (Date.now() - this.createdAt > this.expiresIn * 1000) {
          this.onWaSessionExpired()
          return
        }
        this.$get(
          WA_LOGIN_STATUS,
          { sessionToken: this.sessionToken },
          (res) => {
            if (res.status === "APPROVED" && res.token) {
              this.$toast(this.i18n.approved_redirecting)
              this.loginByToken(res.token)
            } else if (res.status === "EXPIRED") {
              this.onWaSessionExpired()
            } else {
              this.pollTimer = setTimeout(poll, 2000)
            }
          },
          (err) => {
            console.log(err)
            // 网络异常不中断,继续轮询
            this.pollTimer = setTimeout(poll, 2000)
          }
        )
      }
      this.pollTimer = setTimeout(poll, 2000)
    },
    // 会话过期:默认转过期态由等待页展示重试;登录页覆盖此方法跳转到等待页
    onWaSessionExpired() {
      this.isExpired = true
    },
    stopPolling() {
      if (this.pollTimer) {
        clearTimeout(this.pollTimer)
        this.pollTimer = null
      }
    }
  },
  destroyed() {
    this.stopPolling()
  }
}
